/* Copyright 2026 Win Solutions. SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial */
import { type FC } from "react";
import { useTranslation } from "react-i18next";

import { useAgenda } from "./AgendaContext";
import styles from "./AgendaBadge.module.css";

export const AgendaBadge: FC<{ userId?: string }> = ({ userId }) => {
  const state = useAgenda()?.state;
  const { t } = useTranslation();
  if (!userId || !state || state.absent) return null;
  const entries =
    state.entries?.filter((entry) => entry.userId === userId) ?? [];
  if (!entries.length) return null;
  return (
    <span className={styles.badges}>
      {entries.map((entry) => (
        <span
          key={entry.index}
          className={styles.badge}
          data-status={entry.status}
          title={`${entry.index + 1}. ${entry.label}`}
          aria-label={t(`agenda.slot_${entry.status}`, {
            number: entry.index + 1,
          })}
        >
          {entry.index + 1}
        </span>
      ))}
    </span>
  );
};
